export enum ExtensionState {
	/** Idle */
	IDLE = 'IDLE',
	/** Ringing */
	RINGING = 'RINGING',
	/** Calling out */
	CALLING = 'CALLING',
	/** Busy (on a call) */
	BUSY = 'BUSY'
}
